// extracted by css-extract-rspack-plugin
export default {"Container":"insights-layout-module__Container__KKd80","Pane":"insights-layout-module__Pane__uJHrX","MainContent":"insights-layout-module__MainContent__HXJGO"};